import { GeoLocationByPlace } from "../types/GeoLocation";
import { DegreeType } from "../types/Weather";

const DEGREE_TYPE_KEY = "degreeType";
const LAST_SEARCHED_LOCATION = "lastSearchLocation";

export const getDegreeTypeInStorage = (): DegreeType => {
  return localStorage.getItem(DEGREE_TYPE_KEY) === 'fahrenheit' ? 'fahrenheit' : 'celsius';
}

export const setDegreeTypeInStorage = (degreeType: DegreeType) => {
  localStorage.setItem(DEGREE_TYPE_KEY, degreeType);
}

export const getLastSearchedLocationInStorage = (): GeoLocationByPlace => {
  const lastSearchedLocStr = localStorage.getItem(LAST_SEARCHED_LOCATION);
  if (!lastSearchedLocStr) {
    return {
      id: -1,
      country_code: "",
      latitude: 1,
      longitude: 1,
      name: "Your Current Location",
      timezone: "",
      isDeviceLocation: true
    };
  }

  const lastSearchedLoc = JSON.parse(lastSearchedLocStr);
  return lastSearchedLoc;
}


export const setLastSearchedLocationInStorage = (lastSearchedLocation: GeoLocationByPlace) => {
  const lastSearchedLocStr = JSON.stringify(lastSearchedLocation);
  localStorage.setItem(LAST_SEARCHED_LOCATION, lastSearchedLocStr);
}